type EmailValidationResponse = {
  success: boolean;
  message: string;
  status?: string;
  subStatus?: string;
};

// Validates the user email address through ZeroBounce
export const validateEmail = async (email: string): Promise<EmailValidationResponse> => {
  try {
    if (!process.env.ZEROBOUNCE_API_KEY || !process.env.ZEROBOUNCE_BASE_URL) {
      // If ZeroBounce is not configured, do not block user registration
      return {
        message: 'Warning: Email validation service is not configured.',
        success: true,
      };
    }
    // if email includes fortunetest.com, skip validation (for testing purposes)
    if (email.endsWith('@fortunetest.com')) {
      return { message: 'Test email, skipping validation.', success: true };
    }

    const zeroBounceRequestUrl = `${process.env.ZEROBOUNCE_BASE_URL}/validate?api_key=${process.env.ZEROBOUNCE_API_KEY}&email=${encodeURIComponent(email)}`;
    const zeroBounceResponse = await fetch(zeroBounceRequestUrl, {
      method: 'GET',
    });
    if (!zeroBounceResponse.ok) {
      throw new Error(`Error validating email with ZeroBounce: ${zeroBounceResponse.statusText}`);
    }
    const zeroBounceData = await zeroBounceResponse.json();

    // Possible statuses: https://www.zerobounce.net/docs/email-validation-api/#status-codes
    if (['invalid', 'abuse', 'spamtrap', 'do_not_mail', 'unknown'].includes(zeroBounceData.status)) {
      return {
        message: `This email address can’t be verified. Please enter a valid, active email.`,
        success: false,
      };
    }
    return {
      message: 'Email address is valid.',
      status: zeroBounceData.status,
      subStatus: zeroBounceData.sub_status,
      success: true,
    };
  } catch (error) {
    return {
      message: 'An error occurred while validating the email address. Please try again later.',
      success: false,
    };
  }
};
